import { FlexProps } from "@chakra-ui/react";
import React from "react";
import { StyledCard } from "./styles";

type cardProps = FlexProps;

const Card: React.FC<cardProps> = ({ ...rest }) => {
  return (
    <StyledCard
      whileHover={{ scale: 1.2 }}
      {...rest}
    ></StyledCard>
  );
};

export default Card;
